var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "browserLockout" } }, [
    _c("div", { staticClass: "vo-card" }, [
      _c(
        "div",
        { staticClass: "icon" },
        [_c("v-icon", { attrs: { large: "" } }, [_vm._v("mdi-alert-circle")])],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._v("BROWSER NOT SUPPORTED")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "context large" },
        [
          _vm._v(
            "Your browser (" +
              _vm._s(_vm._f("camelToReadable")(_vm.browser.name)) +
              " v" +
              _vm._s(_vm.browser.version) +
              ") is not supported. Vilio supports the newest version of \n        "
          ),
          _vm._l(_vm.browsers, function(b, i) {
            return _c(
              "span",
              {
                key: i,
                staticClass: "link",
                on: {
                  click: function($event) {
                    _vm.openLink(b.link)
                  }
                }
              },
              [
                _vm._v(_vm._s(b.name)),
                i === _vm.browsers.length - 2
                  ? _c("span", [_vm._v(", and ")])
                  : i != _vm.browsers.length - 1
                    ? _c("span", [_vm._v(", ")])
                    : _c("span", [_vm._v(".")])
              ]
            )
          }),
          _vm._v(
            "\n        Download a supported browser to use Vilio.\n        "
          ),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n        Select a browser below to be redirected to its download page.\n      "
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        _vm._l(_vm.browsers, function(b, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "browser",
              on: {
                click: function($event) {
                  _vm.openLink(b.link)
                }
              }
            },
            [
              _c("div", {
                staticClass: "logo",
                style: {
                  backgroundImage: "url(./assets/browserLogos/" + b.icon + ")"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [_vm._v(_vm._s(b.name))])
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "context bottom" }, [
        _vm._v("\n        If you believe this is an error, please "),
        _c("a", { attrs: { href: _vm.contact, target: "_blank" } }, [
          _vm._v("contact us")
        ]),
        _vm._v(" or use our "),
        _c("a", { attrs: { href: _vm.feedback, target: "_blank" } }, [
          _vm._v("Feedback system")
        ]),
        _vm._v(". \n      ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-730302aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730302aa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrowserLockout.vue
// module id = 455
// module chunks = 4